const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    md: 900,
    lg: 1200,
    xl: 1536,
    xxl: 1920, // custom breakpoint
    xxxl: 2400, // custom breakpoint
  },
};
export default breakpoints;
